// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"node_modules_dompurify_dist_purify_js":1,"node_modules_canvg_lib_index_es_js":1,"node_modules_html2pdf_js_node_modules_dompurify_dist_purify_es_mjs":1}[chunkId]) return "scripts/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};